// errors/NotAuthorizedError.ts
import { BaseError } from "@adornis/validation/errors/BaseError";
var NotAuthorizedError = class extends BaseError {
  constructor(extensions = {}) {
    if (!extensions.translationKey)
      extensions.translationKey = "baseql_notAuthorized";
    super("not authorized", extensions);
  }
  static createFromDetails(message, extensions) {
    return new this(extensions);
  }
};
NotAuthorizedError._class = "NotAuthorizedError";
export {
  NotAuthorizedError
};
